import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import PlayTrackLink from '../PlayTrackLink';

export default class InterviewHero extends Component {
  render() {
    const dynamicStyles = StyleSheet.create({
      hero_container: {
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundImage: this.props.image ? 'url("' + this.props.image + '")' : null,
      },
    });

    return (
      <div className={css(styles.container, dynamicStyles.hero_container)}>
        <div className={css(styles.hero_container)}>
          <div className={css(styles.row)}>
            <div className={css(styles.title)}></div>
            <div className={css(styles.title)}>{this.props.title}</div>
            <div className={css(styles.subtitle)}>
              <div className={css(styles.left_subtitle)}>{this.props.category ? this.props.category : ''}</div>
              <div className={css(styles.right_subtitle)}>{this.props.date}</div>
              {
                this.props.track && this.props.track.stream_url ? (
                  <PlayTrackLink track={this.props.track} dispatch={this.props.dispatch} />
                ) : false
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100vw',
    backgroundColor: Theme.black,
    height: window.innerHeight - Theme.navigation.height - Theme.player.height,
  },
  hero_container: {
    display: 'flex',
    flexDirection: 'column',
    width: Theme.container_width,
    paddingBottom: 40,
    boxSizing: 'border-box',
    margin: '0px auto',
    height: '100%',
    [Theme.mobile_query]: {
      width: '100%',
      paddingBottom: 0,
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-end',
    [Theme.mobile_query]: {
      justifyContent: 'center',
    }
  },
  title: {
    fontFamily: Theme.fontFamily,
    fontWeight: '900',
    color: Theme.white,
    fontSize: 48,
    lineHeight: '64px',
    width: 500,
    [Theme.mobile_query]: {
      textAlign: 'center',
      width: '100%',
    }
  },
  subtitle: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 25,
    fontFamily: Theme.fontFamily,
    fontWeight: '400',
    color: Theme.white,
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 1,
    [Theme.mobile_query]: {
      justifyContent: 'center',
      alignItems: 'center'
    },
  },
  left_subtitle: {
    paddingRight: 20,
    borderRight: `1px solid ${Theme.white}`,
  },
  right_subtitle: {
    marginLeft: 20,
    [Theme.mobile_query]: {
      marginLeft: 0,
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/InterviewHero/index.js